import { render, staticRenderFns } from "./CbsDataObject.vue?vue&type=template&id=4e9a8cc7&scoped=true"
import script from "./CbsDataObject.vue?vue&type=script&lang=js"
export * from "./CbsDataObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a8cc7",
  null
  
)

export default component.exports